exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".need-help[data-v-369508f6]{display:flex;max-width:312px;width:100%;justify-content:space-between}.content[data-v-369508f6]{max-width:213px}", ""]);

// exports
